import {
  DELETE_POSITIONS,
  GET_POSITIONS,
  HIDE_POSITIONS_LOADER,
  ADD_POSITIONS,
  SET_POSITIONS,
  SHOW_POSITIONS_LOADER,
  GET_POSITIONS_FOR_ID,
  SET_POSITIONS_FOR_ID,
  PATCH_POSITIONS,
  SET_GROUPS,
  GET_GROUPS,
} from "./actionType";

export const getGroups = () => ({
  type: GET_GROUPS,
});

export const setGroups = data => ({
  type: SET_GROUPS,
  payload: data,
});

export const getPositionsList = data => ({
  type: GET_POSITIONS,
  payload: data,
});

export const getPositionsById = id => ({
  type: GET_POSITIONS_FOR_ID,
  payload: { id },
});

export const setPositionsForId = payload => ({
  type: SET_POSITIONS_FOR_ID,
  payload,
});

export const setPositions = payload => ({
  type: SET_POSITIONS,
  payload,
});

export const showPositionsLoader = () => ({
  type: SHOW_POSITIONS_LOADER,
});

export const hidePositionsLoader = () => ({
  type: HIDE_POSITIONS_LOADER,
});

export const addPosition = (position = {}, data = {}) => ({
  type: ADD_POSITIONS,
  payload: { position, data },
});

export const deletePosition = (id, data = {}) => ({
  type: DELETE_POSITIONS,
  payload: { id, data },
});

export const patchPositions = (id, update = {}, data = {}) => ({
  type: PATCH_POSITIONS,
  payload: { id, update, data },
});
